import axiosInstance from "../utils/axiosInstance"
import { API_ENDPOINTS } from "../constants/config"

export const fetchCustomers = (params = {}) =>
  axiosInstance.get(API_ENDPOINTS.customers, { params }).then((r) => r.data)

export const fetchCustomersList = (params = {}) =>
  axiosInstance.get(API_ENDPOINTS.customers, { params }).then((r) => r.data)

export const createCustomer = (data) =>
  axiosInstance.post(API_ENDPOINTS.customers, data).then((r) => r.data)

export const updateCustomer = (id, data) =>
  axiosInstance.put(API_ENDPOINTS.customer(id), data).then((r) => r.data)

export const fetchLedgerSummary = () =>
  axiosInstance.get(API_ENDPOINTS.customerLedgerSummary).then((r) => r.data)

export const fetchCustomerLedger = (customerId, params = {}) =>
  axiosInstance.get(API_ENDPOINTS.customerLedger(customerId), { params }).then((r) => r.data)

export const createLedgerEntry = (data) =>
  axiosInstance.post(API_ENDPOINTS.ledger, data).then((r) => r.data)

export const addPayment = (entryId, amount, paymentDate, notes) =>
  axiosInstance.post(API_ENDPOINTS.ledgerPayment(entryId), { amount, payment_date: paymentDate, notes }).then((r) => r.data)

export const fetchCustomerPaymentLogs = (customerId, params = {}) =>
  axiosInstance.get(API_ENDPOINTS.customerPaymentLogs(customerId), { params }).then((r) => r.data)

export const createVendor = (data) =>
  axiosInstance.post(API_ENDPOINTS.vendors, data).then((r) => r.data)

export const updateVendor = (id, data) =>
  axiosInstance.put(API_ENDPOINTS.vendor(id), data).then((r) => r.data)

export const fetchVendorsList = (params = {}) =>
  axiosInstance.get(API_ENDPOINTS.vendors, { params }).then((r) => r.data)

export const fetchVendorSummary = () =>
  axiosInstance.get(API_ENDPOINTS.vendorSummary).then((r) => r.data)

export const fetchVendorLedgerSummary = () =>
  axiosInstance.get(API_ENDPOINTS.vendorLedgerSummary).then((r) => r.data)
